import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

const lockPulse = {
    animate: { opacity: [1, 0.6, 1], scale: [1, 1.06, 1] },
    transition: { duration: 2.5, repeat: Infinity, ease: "easeInOut" },
};

function Bar({ label, value, delay }) {
    const [w, setW] = useState(0);
    useEffect(() => {
        const t = setTimeout(() => setW(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    return (
        <div>
            <div className="flex items-center justify-between text-sm text-klareet-MUT mb-2">
                <span>{label}</span>
                <span className="font-mono tabular-nums text-klareet-TEXT">
                    {value}
                </span>
            </div>
            <div className="h-2 rounded-full bg-klareet-BOR overflow-hidden">
                <div
                    className="h-full bg-gradient-to-r from-klareet-T to-klareet-T2 rounded-full transition-[width] duration-[900ms] ease-[cubic-bezier(.2,.8,.2,1)]"
                    style={{ width: `${w}%` }}
                />
            </div>
        </div>
    );
}

function LockedRow({ label }) {
    return (
        <div className="relative">
            <div className="select-none" style={{ filter: "blur(4px)" }} aria-hidden>
                <div className="flex items-center justify-between text-sm text-klareet-MUT mb-2">
                    <span>{label}</span>
                    <span className="font-mono tabular-nums">72</span>
                </div>
                <div className="h-2 rounded-full bg-klareet-BOR overflow-hidden">
                    <div
                        className="h-full bg-gradient-to-r from-klareet-T to-klareet-T2 rounded-full"
                        style={{ width: "72%" }}
                    />
                </div>
            </div>
            <div className="absolute inset-0 grid place-items-center">
                <motion.span
                    {...lockPulse}
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-klareet-bor bg-klareet-card text-klareet-MUT text-xs"
                >
                    <Lock size={12} />
                    Unlocks at launch
                </motion.span>
            </div>
        </div>
    );
}

export function OceanBars({ baseScore = 60 }) {
    const seed = Math.max(30, Math.min(94, baseScore));
    const b1 = Math.max(25, Math.min(95, seed + ((seed * 7) % 13) - 6));
    const b2 = Math.max(25, Math.min(95, seed + ((seed * 3) % 11) - 5));
    const b3 = Math.max(25, Math.min(95, seed + ((seed * 5) % 9) - 4));
    return (
        <div
            className="rounded-3xl border border-klareet-bor bg-klareet-card p-6 md:p-8 animate-fade-up"
            data-testid="ocean-bars"
        >
            <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono mb-6">
                Psychology profile · preview
            </div>
            <div className="space-y-5">
                <Bar label="How you learn and think" value={b1} delay={100} />
                <Bar label="How you approach work" value={b2} delay={200} />
                <Bar label="How you work with others" value={b3} delay={300} />
                <div className="h-px bg-klareet-bor my-4" />
                <LockedRow label="Emotional patterns" />
                <LockedRow label="Openness to change" />
            </div>
        </div>
    );
}
